import * as React from 'react';
import { useEffect, useState } from 'react';
import { ServiceCard } from '../ui/services/ServiceCard';
import { ServiceSectionHeader } from '../ui/services/ServiceSectionHeader';
import { client, urlFor } from '@/sanity/client';

const ServicesSection: React.FC = () => {
	const [serviceCategories, setServiceCategories] = useState([]);
	const [isLoading, setIsLoading] = useState(true);
	const [isContentReady, setIsContentReady] = useState(false);

	useEffect(() => {
		const fetchServices = async () => {
			setIsLoading(true);
			try {
				const data =
					await client.fetch(`*[_type == "serviceCategory"] | order(order asc){
					name,
					subtitle,
					order,
					isBusiness,
					"services": *[_type == "service" && references(^._id)]{
						title,
						slug,
						description,
						image,
						frequency,
						location,
						duration,
						format,
						isPOA,
						price,
						inPersonPrice,
						inPersonPriceValue,
						isPerHour,
						requiresConsultation,
						consultationPrice,
						isBookable,


						benefits,
						workbook,
					}
				}`);
				setServiceCategories(data);
				setIsLoading(false);

				setTimeout(() => {
					setIsContentReady(true);
				}, 300);
			} catch (error) {
				console.error('Error fetching services:', error);
				setIsLoading(false);
				setIsContentReady(true);
			}
		};

		fetchServices();
	}, []);

	if (isLoading || !isContentReady) {
		return (
			<div className='min-h-[300px] flex items-center justify-center'>
				<span className='text-sm text-gray-500'>Loading services...</span>
			</div>
		);
	}

	return (
		<div className='flex flex-col gap-16 md:p-4 p-8'>
			{serviceCategories
				.filter((category) => category.services && category.services.length > 0)
				.map((categoryData, categoryIndex) => (
					<section
						key={categoryIndex}
						className='flex flex-col items-center w-full '
					>
						<ServiceSectionHeader
							title={categoryData.name}
							subtitle={categoryData.subtitle}
						/>

						<div className='w-full mt-8 md:mt-10'>
							<div className='flex flex-col gap-8 md:flex-row md:gap-12 mx-auto flex-wrap md:justify-center'>
								{categoryData.services.map((service, serviceIndex) => (
									<ServiceCard
										key={`${categoryIndex}-${serviceIndex}`}
										id={service.slug.current}
										title={service.title}
										description={service.description}
										imageUrl={urlFor(service.image).url()}
										duration={
											service.duration === 0
												? 'Tailored'
												: service.duration + ' ' + service.format
										}
										frequency={service.frequency}
										location={service.location}
										price={service.price}
										isPerHour={service.isPerHour}
										isPOA={service.isPOA}
										isDark={categoryData.isBusiness}
										isBookable={service.isBookable}
									/>
								))}
							</div>
						</div>
					</section>
				))}
		</div>
	);
};

export default ServicesSection;
